import Vue from 'vue';
import recipeIngredienceTransformer from '../../transformers/recipeIngredience';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('addRecipeIngredience', recipeIngredienceTransformer.fetch(response.data));
  resolve();
};

const failed = (errors, reject) => {
  reject(recipeIngredienceTransformer.fetch(errors));
};

export default recipeIngredience => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/production/recipe_ingredience', recipeIngredienceTransformer.send(recipeIngredience))
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeIngredience/store.js